<template>
    <div class="news">
        <div class="news_hea">
            <myHeaderW></myHeaderW>
        </div>
        <div class="news_ban">
            <img :src="$httpImg +'/img/bag/cooperation.png'" />
            <div class="news_ban_center">
                <el-input v-model="data.input" style="max-width: 600px" placeholder="输入职位关键词" class="input-with-select">
                    <template #prepend>
                        <el-button :icon="Search" />
                    </template>
                    <template #append>
                        <p style="color: #66CADB;font-size: 16px;cursor: pointer;" @click="seachInput('/wantedlist')">职位搜索</p>
                    </template>
                </el-input>
            </div>
        </div>
        <div class="wanted_cen">
            <div class="wanted_cen_ul">
                <div class="li" v-for="i, index in data.dataSce" :key="i.id" :class="data.activeIndex == index ? 'activeIndex' : ''"
                    @click="handleClick(index,i.id)">
                    <h4>{{ i.name }}</h4>
                    <div class="li_bot">
                        <p>{{ i.department }} <span></span>{{ i.location }}</p>
                        <img :src="$httpImg +'/img/icon/wanted_icon_w.png'" v-if="data.activeIndex == index" />
                        <img :src="$httpImg +'/img/icon/wanted_icon.png'" v-else />

                    </div>
                </div>

            </div>
        </div>
        <myFooter></myFooter>

    </div>
</template>

<script>
import { ArrowRight } from '@element-plus/icons-vue'
import { reactive, ref, toRefs, } from "@vue/reactivity";
import myHeaderW from '@/components/myHeaderW.vue'
import myFooter from '@/components/myFooter.vue'
import { Search } from '@element-plus/icons-vue'
import { onMounted } from "vue";
import { getrecruitment } from '@/comm/api'
import { useRouter } from 'vue-router';
export default {
    components: {
        myHeaderW,
        myFooter
    },
    setup() {
        const activeName = ref('0')
        let data = reactive({
            dataSce: [],
            ht: '11111111111111内容',
            activeIndex: 0,
            input:''

        });

        const handleClick = (index, id) => {
            data.activeIndex = index
            goto('/wanteddetails',id)
        }
        const getList = async () => {
            try {
                const res = await getrecruitment();
                if(res.code==1){
                    data.dataSce=res.data
                }
            } catch (err) {
                console.error("失败", err);

            }
        };
     
        const router = useRouter() 
        const goto = (path,id) => {
            router.push({path: path,query:{id:id}})
        }
        const seachInput = (path) => {
            router.push({path: path,query:{name:data.input}})
        }
        onMounted(()=>{
            getList()
        })
        return {
            data,
            activeName,
            handleClick,
            seachInput,
            ArrowRight,
            Search,
            getList,
            goto,
     
        }
    }
}
</script>

<style lang="scss" scoped>
.news {
    background: #F5F5F5;
}

.news_hea {
    width: 100%;
    background: #fff;
}

.news_ban {
    position: relative;

    img {
        position: relative;
        width: 100%;
    }

    .news_ban_center {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 500px;
        transform: translate(-50%, -50%);
        border: 1px solid #fff;
        border-radius: 30px;

        h4 {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 45px;
            color: #FFFFFF;
            text-align: center;
        }

        p {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 20px;
            text-align: center;
            color: #FFFFFF;
        }
    }

}

.wanted_cen {
    background: #F2F2F2;
    padding: 40px;
    padding-top: 100px;
    height: 650px;

    .wanted_cen_ul {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;

        .li {
            width: 300px;
            height: 150px;
            padding: 40px;
            padding-top: 20px;
            padding-bottom: 0px;
            background: #fff;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-bottom: 20px;



            h4 {
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 24px;
                color: #474B55;

                cursor: pointer;
            }

            p {
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #A3A5AC;

                cursor: pointer;

                span {
                    display: inline-block;
                    width: 1px;
                    height: 10px;
                    border-radius: 1px;
                    border-left: 1px solid #ABAAAA;
                    margin-left: 5px;
                    margin-right: 5px;

                    cursor: pointer;
                }
            }

            .li_bot {
                display: flex;
                align-items: center;
                width: 100%;
                justify-content: space-between;
            }
        }
    }
}

.activeIndex {
    background: url('../../assets/img/bag/wanted_bag_h.png') no-repeat !important;
    background-size: 100% 100%;

    h4 {
        color: #fff !important;
    }

    p {
        color: #fff !important;

        span {
            border-left: 1px solid #fff !important;
        }
    }
}

:deep(.el-input-group) {
    height: 50px;
    border-radius: 30px;
}

:deep(.el-input-group__prepend) {
    border-radius: 30px 0px 0px 30px;
    box-shadow: 0 0px 0px 0px var(--el-input-border-color, var(--el-border-color)) inset;
    background: transparent !important;
}

:deep(.el-input-group__append) {
    border-radius: 30px 30px 30px 30px;
    background: #fff !important;
    box-shadow: 0 0px 0px 0px var(--el-input-border-color, var(--el-border-color)) inset;
    width: 100px;
}

:deep(.el-input-group__append > p) {
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 17px;
    color: #66CADB;
}

:deep(.el-input-group--append > .el-input__wrapper) {
    background: transparent !important;
    color: #fff;
    box-shadow: 0 0px 0px 0px var(--el-input-border-color, var(--el-border-color)) inset;
    cursor: text;
}

:deep(.el-input__inner) {
    color: #fff !important;
}

:deep(.el-icon svg) {
    color: #fff !important;
}
.flex_center{
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>